"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.4.1'] && _();
}
catch (e) { }
